<button class="btn-nieuwestroom" [dropdownWrapTrigger]="dropdownOptions">
    <mat-icon *ngIf="icon" inline=true class="btn-nieuwestroom-maticon">{{icon}}</mat-icon>
    {{text}}
</button>


<dropdown-button-wrapper #dropdownOptions>
    <div class="dropdown-item" *ngFor="let option of options" (click)="selectOption(option)">{{option}}
    </div>
</dropdown-button-wrapper>